"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeInspectionModificationRequest = void 0;
const luxon_1 = require("luxon");
const user_1 = require("./user");
const createSomeInspectionModificationRequest = ({ id = '123', targetDeliverableId = '123', items = [
    createSomeInspectionModificationRequestItem(),
    createSomeInspectionModificationRequestItem(),
    createSomeInspectionModificationRequestItem(),
], sender = user_1.createSomeDirectorUser(), } = {}) => ({
    id,
    targetDeliverableId,
    items,
    sender,
    createdAt: luxon_1.DateTime.fromMillis(0, { zone: 'utc' }).toISO(),
});
exports.createSomeInspectionModificationRequest = createSomeInspectionModificationRequest;
const createSomeInspectionModificationRequestItem = ({ type = createSomeInspectionModificationRequestItemType(), body = 'Natto smells awful, but tastes terrific.', } = {}) => ({ type, body });
const createSomeInspectionModificationRequestItemType = ({ id = '333', label = 'Please clarify creative theme', } = {}) => ({ id, label });
